class DetailsModal extends HTMLElement {
	constructor() {
		super();
		this.detailsContainer = this.querySelector('details');
		this.summaryToggle = this.querySelector('summary');
		this.queryMap = {};
		this.searchResultsElement = this.querySelector('.search__results');
		this.detailsContainer.addEventListener(
			'keyup',
			(event) => event.code.toUpperCase() === 'ESCAPE' && this.close(),
		);
		this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
		this.querySelector('button[type="button"]').addEventListener(
			'click',
			this.close.bind(this),
		);

		this.querySelector('input[type="search"]').addEventListener(
			'input',
			this.search.bind(this),
		);
		this.summaryToggle.setAttribute('role', 'button');
	}

	isOpen() {
		return this.detailsContainer.hasAttribute('open');
	}

	onSummaryClick(event) {
		event.preventDefault();
		event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
	}

	onBodyClick(event) {
		if (!this.contains(event.target) || event.target.classList.contains('modal-overlay'))
			this.close(false);
	}

	open(event) {
		this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
		event.target.closest('details').setAttribute('open', true);
		document.body.addEventListener('click', this.onBodyClickEvent);
		document.body.classList.add('overflow-hidden');

		trapFocus(
			this.detailsContainer.querySelector('[tabindex="-1"]'),
			this.detailsContainer.querySelector('input:not([type="hidden"])'),
		);
	}

	close(focusToggle = true) {
		removeTrapFocus(focusToggle ? this.summaryToggle : null);
		this.detailsContainer.removeAttribute('open');
		document.body.removeEventListener('click', this.onBodyClickEvent);
		document.body.classList.remove('overflow-hidden');
	}

	resetSearch() {
		this.searchResultsElement.innerHTML =
			'<div class="search-layout">\n<div class="search-layout__section"></div>\n<div class="search-layout__section search-layout__section--secondary"></div>\n</div>';
	}

	search(event) {
		var _this18 = this;
		//
		if (event.keyCode === 13) {
			return;
		}

		// Unfortunately, fetch does not support as of today cancelling a request. As a consequence what we do is that we manually
		// keep track of sent requests, and only use the results of the last one
		this.lastInputValue = event.target.value;

		if (this.lastInputValue === '') {
			this.resetSearch();
			return;
		}
		const queryOptions = { method: 'GET', credentials: 'same-origin' };

		const queries = [
			fetch(
				'/search?view=ajax&q=' + encodeURIComponent(this.lastInputValue) + '*&type=product',
				queryOptions,
			),
		];

		queries.push(
			fetch(
				'/search?view=ajax&q=' +
					encodeURIComponent(this.lastInputValue) +
					'*&type=article,page',
				queryOptions,
			),
		);

		this.queryMap[this.lastInputValue] = true;
		Promise.all(queries).then(function (responses) {
			// If we receive the result for a query that is not the last one, we simply do not process the result
			if (_this18.lastInputValue !== event.target.value) {
				return;
			}
			delete _this18.queryMap[event.target.value];
			//
			Promise.all(
				responses.map(function (response) {
					return response.text();
				}),
			).then(function (contents) {
				_this18.searchResultsElement.innerHTML =
					'<div class="search-layout">\n<div class="search-layout__section">' +
					contents[0] +
					'</div>\n<div class="search-layout__section search-layout__section--secondary">' +
					contents[1] +
					'</div>\n</div>';
			});
		});
	}
}

customElements.define('details-modal', DetailsModal);
